/**
 * Remove código do país (+55) e caracteres não numéricos do telefone
 * @param phoneNumber - Número de telefone com ou sem formatação
 * @returns Número limpo com apenas dígitos (10 ou 11 dígitos)
 */
export function cleanPhoneNumber(phoneNumber: string | null | undefined): string {
  if (!phoneNumber) {
    return '';
  }

  let cleanPhone = phoneNumber.replace(/\D/g, '');

  if (cleanPhone.length > 11 && cleanPhone.startsWith('55')) {
    cleanPhone = cleanPhone.substring(2);
  }

  return cleanPhone;
}





